import React from 'react';

import InputField from './InputField';
import { validateEmail, validateMinLength } from '../validations/validations';

type PropsType = {
    minLength?: number,
    name: string,
    label: string,
    value: string,
    required?: boolean,
    helperText?: string,
    sx?: {[key: string]: string | number },
    variant?: 'filled' | 'outlined' | 'standard',
    disabled?: boolean,
    onChange: (a: any) => void
};

export default function TextField(props: PropsType) {
    const { minLength, ...baseProps } = props;

    const validations = [
        validateEmail({ value: baseProps.value })
    ];

    if (minLength) {
        validations.push(validateMinLength({ value: baseProps.value, minLength }));
    }

    return (
        <InputField
            {...baseProps}
            validations={validations}
        />
    );
}
